/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Loud_Frog_LurkInputs */

const en_fast_loud_frog_lurk = /** @type {(inputs: Fast_Loud_Frog_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create group`)
};

const de_fast_loud_frog_lurk = /** @type {(inputs: Fast_Loud_Frog_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe erstellen`)
};

/**
* | output |
* | --- |
* | "Create group" |
*
* @param {Fast_Loud_Frog_LurkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_loud_frog_lurk = /** @type {((inputs?: Fast_Loud_Frog_LurkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Loud_Frog_LurkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_loud_frog_lurk(inputs)
	return de_fast_loud_frog_lurk(inputs)
});